var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp-search"},[_c('v-text-field',{staticClass:"rounded-pill",attrs:{"label":"気になるキーワードを入力","prepend-inner-icon":"mdi-magnify","hide-details":"","outlined":"","clearable":"","dense":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }